var exports = {
  "ST": "FavoritesChannelListContent.module__channelBadgeSelected___amxNb1",
  "pJ": "FavoritesChannelListContent.module__channelBadgeSelectedIcon___amxNb1",
  "Vm": "FavoritesChannelListContent.module__favoriteItemContainer___amxNb1",
  "eb": "FavoritesChannelListContent.module__favoriteItem___amxNb1",
  "bu": "FavoritesChannelListContent.module__favoriteItemDefault___amxNb1",
  "Vb": "FavoritesChannelListContent.module__favoriteItemSelected___amxNb1",
  "q6": "FavoritesChannelListContent.module__favoriteItemOver___amxNb1",
  "xQ": "FavoritesChannelListContent.module__favoriteItemMuted___amxNb1",
  "H": "FavoritesChannelListContent.module__avatarContainer___amxNb1",
  "my": "FavoritesChannelListContent.module__avatar___amxNb1",
  "rZ": "FavoritesChannelListContent.module__avatarPlaceholder___amxNb1",
  "XQ": "FavoritesChannelListContent.module__channelBadge___amxNb1",
  "gg": "FavoritesChannelListContent.module__channelBadgeIcon___amxNb1",
  "QC": "FavoritesChannelListContent.module__displayName___amxNb1",
  "Hq": "FavoritesChannelListContent.module__actionsContainer___amxNb1",
  "af": "FavoritesChannelListContent.module__categoryItem___amxNb1",
  "Yq": "FavoritesChannelListContent.module__categoryContent___amxNb1",
  "yb": "FavoritesChannelListContent.module__categoryName___amxNb1",
  "Yl": "FavoritesChannelListContent.module__categoryIcon___amxNb1",
  "wp": "FavoritesChannelListContent.module__categoryActions___amxNb1",
  "Ef": "FavoritesChannelListContent.module__hoverAffordance___amxNb1",
  "It": "FavoritesChannelListContent.module__categoryAddButton___amxNb1",
  "n3": "FavoritesChannelListContent.module__categoryAddButtonIcon___amxNb1",
  "NP": "FavoritesChannelListContent.module__navigationContainer___amxNb1",
  "r0": "FavoritesChannelListContent.module__channelGroupsContainer___amxNb1",
  "kj": "FavoritesChannelListContent.module__uncategorizedGroup___amxNb1",
  "Mn": "FavoritesChannelListContent.module__keyboardFocus___amxNb1",
};

module.exports = exports;
